@if ({
  product: product$ | async,
  }; as content) {
  @if (!content.product) {
    <local-loader></local-loader>
  } @else {
    @if (content.product?.assetTypes?.length || content.product?.literatures?.length) {
      <ul>
        @if (content.product?.assetTypes?.length) {
          @for (item of content.product?.assetTypes; track item) {
            <li>
              <a [href]="item.url" target="_blank" rel="noopener noreferrer">
                <span class="material-symbols-outlined"> download </span>
                <div class="box-titles">
                  <span class="title">{{ item.type }}</span>
                  <span class="sub-title">{{ item.value }}</span>
                </div>
              </a>
            </li>
          }
        }
        @if (content.product?.literatures?.length) {
          @for (item of content.product?.literatures; track item) {
            <li>
              <a [href]="item.documentLink" target="_blank" rel="noopener noreferrer">
                <span class="material-symbols-outlined"> download </span>
                <div class="box-titles">
                  <span class="title">{{ item.title }}</span>
                </div>
              </a>
            </li>
          }
        }
      </ul>
    } @else {
      <p class="text-center">{{ 'resourceCenter.noContent' | cxTranslate }}</p>
    }
  }
}
